import { ArrowLeftIcon } from '@heroicons/react/24/solid';
import { Button } from '@heroui/react';
import { useNavigate } from 'react-router-dom';
import OrganizationForm from './organization-form';

export default function NewOrganization() {
  const navigate = useNavigate();
  return (
    <div className='flex flex-col gap-8 max-w-screen-2xl'>
      <div className='flex items-center gap-2'>
        <Button isIconOnly variant='flat' color='primary' onPress={() => navigate(-1)}>
          <ArrowLeftIcon className='size-4' />
        </Button>
        <h4 className='text-primary-600'>New Organization</h4>
      </div>
      <div className='flex flex-col'>
        <OrganizationForm organization={null} />
      </div>
    </div>
  );
}
